import React, { useEffect, useMemo, useState } from 'react'
import { LicenseCard } from '../../components/LicenseCard'
import Button from '../../components/Button'
import PurchaseDetailsModal from '../../components/PurchaseDetailsModal'
import { useGetTriningCoursesListApiMutation } from '../../redux/api/getLicenseProductsApi'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { formatAmount } from '../../utilities/helpers'
import { commonLabelName } from '../../utilities/commonConstants'

interface License {
    ProductCode: string
    id: string
    title: string
    term: string
    imageSrc: string
    unitPricewithoutMaintenance: string | 'Free'
    price: string | 'Free'
    type: 'priced' | 'free'
}

interface CommercialLicensesProps {
    selectedLicenses: Set<string>
    setSelectedLicenses: React.Dispatch<React.SetStateAction<Set<string>>>
    quantities: Record<string, number>
    setQuantities: React.Dispatch<React.SetStateAction<Record<string, number>>>
    setMainTab: React.Dispatch<React.SetStateAction<'productDownloads' | 'myLicenses' | 'commercial' | 'academic' | 'training'>> | any
    selectedLicensesDetails: {
        ProductCode: string
        ProductName: string
        Quantity: number
        Price: string
        UiPrice: string
        Term: string
    }[]
    setSelectedLicensesDetails: React.Dispatch<
        React.SetStateAction<
            {
                ProductCode: string
                ProductName: string
                Quantity: number
                Price: string
                UiPrice: string
                Term: string
            }[]
        >
    >
    setModalOpen: React.Dispatch<React.SetStateAction<boolean>>
    isModalOpen: boolean
    onLoadingChange?: (isLoading: boolean) => void
}

const CommercialTrainingCourses: React.FC<CommercialLicensesProps> = ({
    selectedLicenses,
    setSelectedLicenses,
    quantities,
    setQuantities,
    setMainTab,
    selectedLicensesDetails,
    setSelectedLicensesDetails,
    setModalOpen,
    isModalOpen,
    onLoadingChange
}) => {
    // const [selectedLicenses, setSelectedLicenses] = useState<Set<string>>(new Set())
    // const [quantities, setQuantities] = useState<Record<string, number>>({})
    // const [isModalOpen, setModalOpen] = useState(false)
    const [licenses, setLicenses] = useState<License[]>([])
    // const [selectedLicensesDetails, setSelectedLicensesDetails] = useState<
    //     { ProductCode: string; ProductName: string; Quantity: number; Price: string; Term: string }[]
    // >([])
    console.log(selectedLicensesDetails, 'selectedLicensesDetails')

    const [GetTrainingCoursesList, { isLoading }] = useGetTriningCoursesListApiMutation()

    const commercialLicensesCodes = ['IDLLIC', 'IDLTLA', 'ENVIDLLIC', 'ENVIDLTLA', 'ENVLIC', 'ENVTLA']
    const trainingCoursesCodes = ['ELNISRS', 'ELNEBG', 'ELNAEG', 'ELNEFUN']

    const computedType = useMemo(() => {
        const selectedCodes = Array.from(selectedLicenses)
        const hasCommercial = selectedCodes.some((code) => commercialLicensesCodes.includes(code))
        const hasTraining = selectedCodes.some((code) => trainingCoursesCodes.includes(code))

        if (hasCommercial && hasTraining) return 'COMMERCIAL,TRAINING'
        if (hasCommercial) return 'COMMERCIAL'
        if (hasTraining) return 'COMMERCIALTRAININGONLY'
        return ''
    }, [selectedLicenses])

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await GetTrainingCoursesList({
                    flow: 'Commercial',
                    licenseType: 'training'
                }).unwrap()

                const transformedCourses: License[] = response?.data?.map((item: any) => ({
                    ProductCode: item.ProductCode,
                    title: item.Name,
                    term: '2 Months Duration',
                    price: item.UnitPrice,
                    imageSrc: item.imageSrc,
                    type: 'priced'
                }))

                setLicenses(transformedCourses)
            } catch (error) {
                console.error('Error fetching data:', error)
            }
        }

        fetchData()
    }, [GetTrainingCoursesList])

    // Notify parent component about loading state changes
    useEffect(() => {
        onLoadingChange?.(isLoading)
    }, [isLoading, onLoadingChange])

    const toggleLicense = (id: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        const newSelected = new Set(selectedLicenses)
        const selectedLicense = licenses?.find((license: License) => license?.ProductCode === id)

        if (!selectedLicense) return
        const licenseDetails = {
            ProductCode: selectedLicense?.ProductCode || '',
            ProductName: selectedLicense?.title || '',
            Quantity: quantities[id] || 0,
            Price: String(selectedLicense?.price),
            UiPrice: selectedLicense?.price,
            Term: selectedLicense?.term
        }

        if (event.target.checked) {
            newSelected.add(id)
            setSelectedLicensesDetails((prev) => [...prev, licenseDetails])
        } else {
            newSelected.delete(id)
            setSelectedLicensesDetails((prev) => prev.filter((item) => item?.ProductCode !== id))
        }
        setSelectedLicenses(newSelected)
    }

    const handleQuantityChange = (id: string, newQuantity: number) => {
        setQuantities((prev) => {
            const updatedQuantities = {
                ...prev,
                [id]: newQuantity > 0 ? newQuantity : 0
            }

            if (newQuantity === 0) {
                const newSelected = new Set(selectedLicenses)
                newSelected.delete(id)
                setSelectedLicenses(newSelected)

                setSelectedLicensesDetails((prevDetails) => prevDetails.filter((item) => item.ProductCode !== id))
            }

            return updatedQuantities
        })
    }

    const renderLicenses = (licenses: License[]) => {
        return (
            licenses &&
            licenses.length > 0 &&
            licenses.map((license) => (
                <LicenseCard
                    key={license.ProductCode}
                    productCode={license?.ProductCode}
                    title={license.title}
                    term={license.term}
                    imageSrc={license.imageSrc}
                    price={formatAmount(Number(license.price))}
                    isSelected={selectedLicenses.has(license.ProductCode)}
                    onSelect={toggleLicense(license.ProductCode)}
                    setQuantity={(newQuantity: number) => handleQuantityChange(license.ProductCode, newQuantity)}
                    quantity={quantities[license.ProductCode]}
                />
            ))
        )
    }

    return (
        <div className='p-6 max-w-7xl mx-auto border border-gray bg-[#f9f9f9] rounded-lg'>
            <div className='mt-2 ml-2'>
                <div className='text-secondary text-center mt-4 font-normal'>
                    <p>Online credit card purchase is available only in the US in USD currency.To order products that</p>
                    <p className='font-normal'>
                        are not shown here, please{' '}
                        <a
                            href='https://www.nv5geospatialsoftware.com/Company/Contact-Us'
                            target='_blank'
                            rel='noopener noreferrer'
                            className='text-primary underline font-semibold'
                        >
                            Contact your Sales Representative
                        </a>
                        &nbsp;or&nbsp;
                        <a
                            href='https://www.nv5geospatialsoftware.com/Request-a-Quote'
                            target='_blank'
                            rel='noopener noreferrer'
                            className='text-primary underline font-semibold'
                        >
                            Request a Quote
                        </a>
                        .
                    </p>
                    <p>
                        Problems? &nbsp;
                        <a
                            href='mailto:geospatialsupport@nv5.com'
                            target='_blank'
                            rel='noopener noreferrer'
                            className='text-primary underline font-semibold'
                        >
                            geospatialsupport@nv5.com
                        </a>
                    </p>
                </div>
            </div>
            <div className='mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6'>
                {isLoading ? (
                    Array.from({ length: 4 }).map((_, index) => (
                        <div key={index} className='bg-gray-200 rounded-lg h-24 p-2 mb-4'>
                            <Skeleton height={100} />
                        </div>
                    ))
                ) : licenses.length > 0 ? (
                    renderLicenses(licenses)
                ) : (
                    <div className='text-center col-span-2 py-10 text-gray-500'>No Training Courses Available</div>
                )}
            </div>

            <div className='flex justify-end mt-6'>
                <Button
                    variant='primary'
                    className={`px-6 py-2 bg-primary text-white rounded-md ${
                        selectedLicenses.size === 0 ? 'opacity-50 cursor-not-allowed' : ''
                    }`}
                    disabled={selectedLicenses.size === 0}
                    onClick={() => {
                        setModalOpen(true)
                    }}
                >
                    {commonLabelName?.proceed}
                </Button>
            </div>

            {isModalOpen && (
                <PurchaseDetailsModal
                    licenses={selectedLicensesDetails}
                    quantities={quantities}
                    onClose={() => setModalOpen(false)}
                    type={computedType}
                    setMainTab={setMainTab}
                    setSelectedLicenses={setSelectedLicenses}
                    setQuantities={setQuantities}
                    setSelectedLicensesDetails={setSelectedLicensesDetails}
                />
            )}
        </div>
    )
}

export default CommercialTrainingCourses
